import type { FunctionComponent } from "react";
import { memo, useMemo } from "react";
import cx from "classnames";

import { GridCell } from "@smartsuite/grid/lib/components/GridCell/GridCell";
import type { Preferences } from "@smartsuite/types/lib/models/preferences";
import type { AppField, Fields } from "@smartsuite/smartsuite-client";
import type { ActivityRecord } from "../../../../../stores/jobs.store";

import { automationsActivityRenders } from "../../../AutomationActivity.contants";

interface GridCompactCellProps {
  record: ActivityRecord;
  field: AppField;
  width: number;
  userPreferences: Preferences;
}

const ActivityGridCellRaw: FunctionComponent<GridCompactCellProps> = (
  props,
) => {
  const { record, field, width, userPreferences } = props;
  const fieldType = field.field_type;

  const value = useMemo(
    () => getValueFromRecordByField(record, field),
    [field, record],
  );

  const { isCentered, component: FieldOutlet } =
    automationsActivityRenders[fieldType];

  const classes = cx("activity-grid-cell", {
    "is-centered": isCentered,
  });
  return (
    <GridCell className={classes} record={record} column={field} width={width}>
      <span style={{ minWidth: width }} className="activity-grid-cell__wrapper">
        <FieldOutlet
          value={value}
          record={record}
          userPreferences={userPreferences}
        />
      </span>
    </GridCell>
  );
};

export const ActivityGridCell = memo(ActivityGridCellRaw);

// ActivityRecord field values are heterogeneous (string | number | undefined);
// grid cells display them as text, so numeric columns (e.g. duration) arrive
// here as strings and downstream renderers rely on JS numeric coercion.
const getValueFromRecordByField = (
  record: ActivityRecord,
  field: AppField,
): string => {
  return String(record[field.slug] ?? "");
};
